import { render, staticRenderFns } from "./c-joinnnbox.vue?vue&type=template&id=7126975e"
import script from "./c-joinnnbox.vue?vue&type=script&lang=js"
export * from "./c-joinnnbox.vue?vue&type=script&lang=js"
import style0 from "./c-joinnnbox.vue?vue&type=style&index=0&id=7126975e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports